import { useEffect,  useState } from "react"
import apis from "../../../api"
import { apiResult,  getUserSession } from "../../../Utils/Common"
import { Box,  Typography } from "@mui/material"
import MemberCourseDailyCard from "../../classes/fragement/MemberCourseDailyCard"

const MemberCourseRecords = (props)=> {
    const {title,memberCourse,onMemberCourseUpdate} = props
    const [records,setRecords] = useState()
    const [error,setError] = useState()
    getUserSession(apis)
    const loadCourseRecord = ()=>{
        apis.memberCourseRecordLoad(memberCourse.id).then((ret)=>{
            apiResult(ret,data=>{                
                setRecords(data)                                
            },setError)
        })
    }
    useEffect(()=>{         
        memberCourse ? loadCourseRecord():setRecords()
    },[memberCourse])    
    const handleEdit = (idx,item)=>{
        onMemberCourseUpdate && onMemberCourseUpdate(item)
    }
    return memberCourse && <Box sx={{...props.sx}} > 
        {title && <Typography variant="body2" sx={{mb:1,ml:1}}>{title}</Typography>}
        {records && records.map((record,idx)=>{            
            return <MemberCourseDailyCard key={idx} onNew={(item)=>{handleEdit(idx,item)}} sx={{bgcolor:idx%2 ==0 ?"#eee2":"#fff"}} onError={setError} classObj={record.class} memberCourse={memberCourse} record={record}/>
        })}
    </Box>
}
export default MemberCourseRecords